import Vue from 'vue'
import App from './App.vue'
import 'mapbox-gl/dist/mapbox-gl.css'
import VueRouter from 'vue-router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faBiking, faWalking, faCar, faBus, faCircle, faInfo, faTimes, faRedo, faPrint, faPlay, faPause, faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.component('multiselect', Multiselect)



Vue.use(VueRouter);

library.add(faBiking);
library.add(faWalking);
library.add(faCar);
library.add(faBus);
library.add(faCircle);
library.add(faInfo);
library.add(faTimes);
library.add(faRedo);
library.add(faPrint);
library.add(faPlay);
library.add(faPause);
library.add(faHome);
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments)
    }
    i[r].l = 1 * new Date()
    a = s.createElement(o)
    m = s.getElementsByTagName(o)[0]
    a.async = 1
    a.src = g
    m.parentNode.insertBefore(a, m)
  })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga')
  // eslint-disable-next-line
  ga('create', 'UA-5355512-14', 'auto')
  // eslint-disable-next-line
  ga('send', 'pageview')
}

let router = new VueRouter({
  mode: 'history',
  routes: [],
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
